module.exports = __webpack_public_path__ + "media/images/logo-square-c4292c4659dcb5cb0d9277e23e3f7f05a5d8b6a92172c24cece8bc36e738b767.png";